import React from "react";

const ComparisonTable = ({ oldData, newData }) => {
  if (!oldData || !newData) return null;

  const keys = Object.keys({ ...oldData, ...newData });

  const formatValue = (value) => {
    if (value === null || value === undefined || value === "") return "-";

    if (Array.isArray(value)) {
      return value.map((v) => v.name || JSON.stringify(v)).join(", ");
    }

    if (typeof value === "object") {
      return JSON.stringify(value);
    }

    return String(value);
  };

  return (
    <table className="w-full text-left border-collapse">
      <thead className="bg-[#F7FAFC] borer-[#E0E0E0] border-b sticky top-0">
        <tr className="">
          <th className="px-4 py-3 font-semibold text-[13px] text-[#13131399]">Field</th>
          <th className="px-4 py-3 font-semibold text-[13px] text-[#13131399]">Old</th>
          <th className="px-4 py-3 font-semibold text-[13px] text-[#13131399]">Updated</th>
        </tr>
      </thead>

      <tbody>
        {keys.map((key) => {
          const oldVal = formatValue(oldData[key]);
          const newVal = formatValue(newData[key]);

          const updated = oldVal !== newVal;

          return (
            <tr key={key} className="border-b">
              <td className="px-4 py-3 text-[13px] text-[#131313] font-normal">{key}</td>

              <td className="px-4 py-3 text-[13px] text-[#131313] font-normal">{oldVal}</td>

              <td className="px-4 py-3 text-[13px] text-[#131313] font-normal flex items-center gap-4">
                <span>{newVal}</span>

                {updated && (
                  <span className="bg-[#39A539] text-white text-xs font-medium px-2 py-1 rounded text-center items-center">
                    Updated
                  </span>
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default ComparisonTable;
